// extracted by mini-css-extract-plugin
module.exports = {"formatBackground":"AdvertiseformatSection_formatBackground__IHZk_"};